import { useRef } from "react";
import "../../components/Header/header.css";
import { Link } from "react-router-dom";
import useOutsideClick from "./useOutsideClick";
import close from "../../assets/close.png";

const Sidebar = ({ showSidebar, setShowSidebar }) => {
  const ref = useRef();

  useOutsideClick(ref, () => {
    setShowSidebar(!showSidebar);
  });
  const toggleSideBar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <>
      <div className={`menu ${showSidebar ? "width:590px" : "width:0px"}`}>
        <div ref={ref}>
          <img
            src={close}
            alt="close"
            className="toggle1"
            onClick={toggleSideBar}
          />
          <ul>
            <li>
              <Link to="/how-it-works" className="links">
                How It Works
              </Link>
            </li>
            <li>
              <Link to="/artists" className="links">
                Artists
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="links">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/community" className="links">
                Community
              </Link>
            </li>
            <li>
              <Link to="/api" className="links">
                API
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
